import "./QuoteOhlcComponent.scss";
import template from "./QuoteOhlcComponent.html";
import {IComponentOptions} from "angular";
import {QuoteViewModel} from "../../models/QuoteViewModel";

export const OHLC = "tfQuoteOhlc";

export function ohlc(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<quote"
        },
        controllerAs: "ctrl",
        controller: QuoteOhlcComponentController
    };
}

export class QuoteOhlcComponentController {
    /** @input */
    public readonly model: QuoteViewModel;

    /** @input */
    public readonly hideLast: boolean;
}
